import { config } from '../config';

type CourseSurveyLinksByType = {
  [creditType: string]: {
    [courseIdentifier: string]: string;
  };
};

const normalizeCourseIdentifier = (value?: string) => {
  if (!value) return '';

  return value.toLowerCase().trim();
};

export const getCourseSurveyLink = (creditType: string, courseIdentifier?: string) => {
  const defaultSurveyUrl = config.creditsLinks[creditType];
  const linksByIdentifier = config.courseSurveyLinks[creditType] as
    | CourseSurveyLinksByType[string]
    | undefined;
  const normalizedIdentifier = normalizeCourseIdentifier(courseIdentifier);

  if (!linksByIdentifier || !normalizedIdentifier) {
    return defaultSurveyUrl;
  }

  return linksByIdentifier[normalizedIdentifier] || defaultSurveyUrl;
};

export const getCourseIdentifierFromItems = (
  items: any[] | undefined,
  selectedCourseId?: string,
) => {
  if (!items?.length || !selectedCourseId) {
    return undefined;
  }

  const selectedCourse = items.find(
    (item: any) => item?._id === selectedCourseId || item?.id === selectedCourseId,
  );

  return (
    selectedCourse?._courseIdentifier ||
    selectedCourse?.sourceData?.[0]?.courseIdentifiers?.[0]
  );
};
